import { Trans } from '@lingui/macro';
import { BRANDS } from 'project-constants';
import { CONFIG } from 'config';

import BzLogo from './assets/bz-main-logo.svg';
import We53Logo from './assets/we53-main-logo.svg';
import styles from './style.module.scss';

const BRANDED_MAIN_LOGO_MAP: Readonly<Record<string, string>> = Object.freeze({
	[BRANDS.bz]: BzLogo,
	[BRANDS.we53]: We53Logo,
});

const Header = () => (
	<header className={styles.header}>
		<div className={styles.logo}>
			<img src={BRANDED_MAIN_LOGO_MAP[CONFIG.brand]} alt="" />
			<span>
				<Trans>city charging rental service</Trans>
			</span>
		</div>
	</header>
);

export default Header;
